// extracted by css-extract-rspack-plugin
export default {"rating":"Rating-module__rating___L2V77","star":"Rating-module__star___CiMzp"};